module.exports = "<div ng-form=\"commandeForm\">\n  <div class=\"row\">\n    <my-input class=\"col s12\"\n      ng-model=\"myCommande.name\"\n      my-options=\"fieldsOptions.name\"\n      enable-validator=\"enableValidator\">\n    </my-input>\n\n    <my-input class=\"col s12\"\n      ng-model=\"myCommande.location\"\n      my-options=\"fieldsOptions.location\"\n      enable-validator=\"enableValidator\">\n    </my-input>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./public/javascript/sygem/entities/commande/directives/forms/myCommandeForm.html
// module id = 1169
// module chunks = 0